
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileTextIcon, Plus, Zap } from "lucide-react";

interface MarkschemeEmptyStateProps {
  onCreateManually: () => void;
  onGenerateWithAI: () => void;
  hasQuestion: boolean;
}

export const MarkschemeEmptyState = ({
  onCreateManually,
  onGenerateWithAI,
  hasQuestion,
}: MarkschemeEmptyStateProps) => {
  return (
    <Card className="border-dashed border-2">
      <CardContent className="flex flex-col items-center justify-center py-12 text-center">
        <FileTextIcon className="h-16 w-16 text-muted-foreground/50 mb-4" />
        <h3 className="text-lg font-semibold mb-2">No Markscheme Created</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          Create a markscheme to help evaluators assess this question consistently and fairly. 
          You can create one manually or let AI generate it based on your question details.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <Button onClick={onCreateManually} variant="outline" className="flex items-center gap-2">
            <Plus className="h-4 w-4" />
            Create Manually
          </Button>
          
          <Button 
            onClick={onGenerateWithAI} 
            className="flex items-center gap-2"
            disabled={!hasQuestion}
          >
            <Zap className="h-4 w-4" />
            Generate with AI
          </Button>
        </div>
        
        {!hasQuestion && (
          <p className="text-xs text-muted-foreground mt-3">
            Complete your question details to enable AI generation
          </p>
        )}
      </CardContent>
    </Card>
  );
};
